"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _text = require("../text");

var _constants = require("./constants");

var TooltipText = _text.Text.withComponent('div', {
  target: "eeny75z0"
});

TooltipText.defaultProps = (0, _objectSpread2.default)({}, _text.Text.defaultProps, {
  fontSize: _constants.TEXT_FONT_SIZE,
  fontWeight: _constants.TEXT_FONT_WEIGHT,
  color: _constants.TEXT_COLOR
});
var _default = TooltipText;
exports.default = _default;